import type { RootState } from '../rootReducers';
import { PROFILE_UNLOADED } from 'reducers/profile/profile.reducer';

/**
 * The current user's profile.
 *
 * The only place audit-admin reads the profile from. It is served over REST from api-users
 * (Mongo-backed) and held in the `profile` slice -- audit-admin holds no RTDB `/user`
 * subscription for it (ADR-065 Phase 3).
 *
 * Two deliberate choices:
 *
 * - The object returned is the one held in the slice, not one composed here. A selector
 *   building a fresh object per call would break useSelector's referential equality and
 *   re-render every consumer on every store change.
 * - The slice is read optionally, falling back to the unloaded shape. Reading it directly
 *   would throw wherever the slice is absent -- a rehydrated persisted state missing the
 *   key, or a test store supplying only part of the tree -- and "unloaded" is the honest
 *   answer there.
 */
export const selectProfile = (state: RootState) => state.profile?.profile ?? PROFILE_UNLOADED;
